
import { SELECTED_COLUMN_MENU_ITEMS, SELECTED_COLUMNS_MAP, } from '@/views/Runnits/constants';
import { setRunnitsSelectedColumnsVal } from '@/utils';
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import BaseStyledMenu from '../base/BaseStyledMenu.vue';
import GlassButton from '../base/GlassButton.vue';

export default Vue.extend({
	name: 'SelectedColumnsButton',
	props: {
		iconOnly: { type: Boolean, default: false },
		iconColor: { type: String, default: 'rgba(255, 255, 255, 0.7)' },
		useRunnitPageStyles: { type: Boolean, default: false },
		value: { type: Number, default: null }, // if null, use vuex store value
	},
	data () {
		return {
			selectColumnsMap: SELECTED_COLUMNS_MAP,
			selectedColumnsMenuItems: SELECTED_COLUMN_MENU_ITEMS,
		}
	},
	computed: {
		...mapState([
			'runnitState',
		]),
		usesLocalState (): boolean {
			return this.value !== null;
		},
		currentSelectedColumns (): number {
			if (this.usesLocalState) return this.value;
			return this.runnitState.selectedColumns;
		},
	},
	methods: {
		...mapActions([
			'updateRunnitState',
		]),
		onSelectColumns (selectedColumns: number) {
			if (this.usesLocalState) {
				this.$emit('input', selectedColumns);
			} else {
				this.updateRunnitState({
					selectedColumns: selectedColumns,
				});
				setRunnitsSelectedColumnsVal(selectedColumns);
			}
		},
	},
	components: {
		BaseStyledMenu,
		GlassButton,
	},
});
